import { render } from "./ShowPost.vue?vue&type=template&id=568f4189&ts=true"
import script from "./ShowPost.vue?vue&type=script&lang=ts"
export * from "./ShowPost.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__